import { FaCheck } from "react-icons/fa6";
import "./index.css";

const steps = [
    { id: 1, label: "Business Details" },
    { id: 2, label: "KYC Verification" },
    { id: 3, label: "Bank Details" },
    { id: 4, label: "Terms & Conditions" },
];

export default function ProgressBar({ currentStep = 1 }) {
    return (
        <div className="custom-stepper-container">
            <div className="custom-stepper-track">
                {steps.map((step, index) => {
                    const isCompleted = step.id < currentStep;
                    const isActive = step.id === currentStep;
                    const isLast = index === steps.length - 1;

                    return (
                        <div key={step.id} className="custom-stepper-step">
                            {!isLast && (
                                <div
                                    className={`custom-stepper-line ${
                                        isCompleted ? "completed-line" : ""
                                    }`}
                                />
                            )}

                            <div className="custom-stepper-node">
                                <div
                                    className={`custom-progress-circle ${
                                        isCompleted ? "completed" : ""
                                    } ${isActive ? "active" : ""}`}
                                >
                                    {isCompleted ? (
                                        <FaCheck className="check-icon" />
                                    ) : (
                                        <span
                                            className={`custom-inner-dot ${
                                                isActive ? "dot-active" : "dot-inactive"
                                            }`}
                                        />
                                    )}
                                </div>

                                <span
                                    className={`custom-step-label ${
                                        isActive
                                            ? "label-active"
                                            : isCompleted
                                            ? "label-completed"
                                            : "label-inactive"
                                    }`}
                                >
                                    {step.label}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

